import { useQuery } from "react-query";

import { Enum_Geometry_Types } from "src/types";

import { getFormsByType } from "./service";

export const useGetFormByType = (type: Enum_Geometry_Types) => {
    return useQuery({
        queryKey: ["forms", type],
        queryFn: () => getFormsByType(type),
        enabled: false,
        select: (data) => {
            if (!data?.success || !data?.data) {
                throw new Error("Wrong format data: useGetFormByType");
            }
            return data.data;
        },
        onError: (err: any) => {
            return err;
        },
    });
};
